import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import Section from '../Section.component'
import Contact from '../../../../components/Contact/Contact.component'
import { Container, ContentContainer, NoResultsFound, SectionsContainer, Title } from './Faq.style'
import { BaseSelect } from 'parkdepot-shared/components/Select'
import { helpRoute } from '@views/Help/route.const'

interface SectionI {
    question: string
    answer: string
    opened: boolean
}

interface Tab {
    order: number
    id: string
    title: string
    sections: SectionI[]
}

const FAQComponent = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const { search } = useLocation()

    const tabs = t('faq.tabs', { returnObjects: true }) as Tab[]
    const sorderTabs = tabs.sort((a, b) => a.order - b.order)
    const selectedTabId = useMemo(() => new URLSearchParams(search).get('tab') ?? null, [search, tabs])
    const selectedTab = sorderTabs.find((tab) => tab.id === selectedTabId)

    const getOptions = (): {
        label: string
        id: string
    }[] => {
        const options = tabs.map((tab) => ({ label: tab.title, id: tab.id }))
        options.push({ label: t('contact.title'), id: 'contact' })
        return options
    }

    return (
        <Container>
            <Title>{t('faq.title')}</Title>
            <ContentContainer>
                <BaseSelect
                    options={getOptions()}
                    value={getOptions().filter((tab) => tab.id === selectedTabId)}
                    onChange={(newValue) => {
                        const tabId = newValue.value[0]?.id
                        history.push(`${helpRoute()}?tab=${tabId}`)
                    }}
                    clearable={false}
                />

                {selectedTabId === null ? (
                    <NoResultsFound>{t('faq.nothingSelected')}</NoResultsFound>
                ) : (
                    <SectionsContainer>
                        {selectedTab ? <Section contentSection={selectedTab.sections} /> : <Contact />}
                    </SectionsContainer>
                )}
            </ContentContainer>
        </Container>
    )
}

export default FAQComponent
